import script from "./ProductStockImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductStockImport.vue?vue&type=script&setup=true&lang=ts"

import "./ProductStockImport.vue?vue&type=style&index=0&id=6092a850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6092a850"]])

export default __exports__